import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OnboardingLayout } from '../Layout';
import { Button } from '@/components/ui/Button';
import { paths } from '@/routes/paths';

export function OnboardingAllSetPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <OnboardingLayout>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          gap: 12,
        }}
      >
        <div style={{ fontSize: 64 }}>🎉</div>
        <h1 style={{ margin: 0 }}>{t('onboarding.all_set.title')}</h1>
        <p style={{ color: 'var(--color-text-on-dark-muted)' }}>{t('onboarding.all_set.body')}</p>
      </div>
      <Button block size="lg" variant="inverted" onClick={() => navigate(paths.home, { replace: true })}>
        {t('onboarding.all_set.continue')}
      </Button>
    </OnboardingLayout>
  );
}
